class Builder {
    addBaseUrl(baseUrl) {
        this.BASE_URL = baseUrl;
        return this;
    }

    addDateParameters(arrival, departure) {
        this.QUERY_PARAMETERS = {
            ...this.QUERY_PARAMETERS,
            ...(!!arrival && !!departure
                ? {arrival, departure}
                : {noDates: true})
        };
        return this;
    }

    addGuestParameters(adultsCount, childrenCount, petIncluded) {
        this.QUERY_PARAMETERS = {
            ...this.QUERY_PARAMETERS,
            ...(adultsCount && {adultsCount}),
            ...(childrenCount && {childrenCount}),
            ...(petIncluded && {petIncluded})
        };
        return this;
    }

    addQueryParameters(values) {
        Object.keys(values).forEach((key) =>
            this.addQueryParameter(key, values[key])
        );
        return this;
    }

    addQueryParameter(key, value) {
        if (value || typeof value === 'number' || typeof value === 'boolean') {
            this.QUERY_PARAMETERS[key] = value;
        }
        return this;
    }

    build() {
        let url = [this.BASE_URL];
        const parameters = Object.keys(this.QUERY_PARAMETERS);
        if (parameters.length) {
            let queryParams = [];
            queryParams = parameters.map(
                (key) => `${key}=${this.QUERY_PARAMETERS[key]}`
            );
            url.push(`?${queryParams.join('&')}`);
        }

        return url.join('');
    }
}

export default class ListingUrlBuilder {
    constructor() {
        throw new Error('You can not construct builder');
    }

    static builder() {
        return new Builder();
    }
}
